module.exports = __webpack_public_path__ + "static/media/contact-img.48d70509.svg";